import { IObjetoContrato } from '../../pages/daf/ProcessosAquisitivos/contratos/objeto';
import httpClient from '../httpClient';

export const getAllObjetoContratos = async () => {
  try {
    const response = await httpClient.get(`/api/objetocontrato`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};
export const getAllObjetoByContrato = async (contratoId: string | number) => {
  try {
    const response = await httpClient.get(
      `/api/objetocontrato/contrato/${contratoId}`,
    );
    console.log(response);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
};

export async function getObjetoContrato(id: string) {
  try {
    const response = await httpClient.get(`/api/objetocontrato/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function handleCreateObjetoContrato(form: IObjetoContrato) {
  try {
    return await httpClient.post(`/api/objetocontrato`, form);
  } catch (error) {
    throw error;
  }
}

export async function handleUpdateObjetoContrato(form: IObjetoContrato) {
  try {
    const response = await httpClient.patch(
      `/api/objetocontrato/${form.id}`,
      form,
    );

    return response;
  } catch (error) {
    throw error;
  }
}

export async function handleDeleteObjetoContrato(id: string | number) {
  try {
    return await httpClient.delete(`/api/objetocontrato/${id}`);
  } catch (error) {
    throw error;
  }
}
